import React, {Component} from 'react';
import {Table, Modal} from 'react-bootstrap';
var dateFormat = require('dateformat');
class CpvalueView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // console.log(this.props.UnitViewDtls);
    const data =
      this.props.CpValueDtls && this.props.CpValueDtls.item
        ? this.props.CpValueDtls && this.props.CpValueDtls.item
        : null;

    // console.log(data);
    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{fontSize: '35px', backgroundColor: '#f0f3f5'}}
              closeButton
            >
              <Modal.Title>
                <span style={{fontSize: '20px'}}>Cp Value Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <div className="feedbkModalTbl">
                  <Table responsive bordered className="cmnMainTable">
                    <tbody>
                      <tr>
                        <td>Gst</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.gst} %
                        </td>
                      </tr>
                      <tr>
                        <td>Service Fee</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.serviceFee} %
                        </td>
                      </tr>
                      <tr>
                        <td>Service Fee Percentage</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.serviceFeePer} %
                        </td>
                      </tr>
                      <tr>
                        <td>Gateway Fee</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.gatewayFee} %
                        </td>
                      </tr>
                      <tr>
                        <td>Created Date</td>
                        <td className="feedbkModalCap">
                          {data !== null &&
                            data.createdAt !== null &&
                            dateFormat(data.createdAt, 'mediumDate')}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{backgroundColor: '#f0f3f5'}} />
          </Modal>
        </div>
      </div>
    );
  }
}
export default CpvalueView;
